// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file crm/v1/account_events.proto (package crm.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Account } from "./account_pb.js";
import { file_crm_v1_account } from "./account_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crm/v1/account_events.proto.
 */
export const file_crm_v1_account_events: GenFile = /*@__PURE__*/
  fileDesc("Chtjcm0vdjEvYWNjb3VudF9ldmVudHMucHJvdG8SBmNybS52MSKnAQoMQWNjb3VudEV2ZW50Ei4KB2NyZWF0ZWQYASABKAsyGy5jcm0udjEuQWNjb3VudENyZWF0ZWRFdmVudEgAEi4KB3VwZGF0ZWQYAiABKAsyGy5jcm0udjEuQWNjb3VudFVwZGF0ZWRFdmVudEgAEi4KB2RlbGV0ZWQYAyABKAsyGy5jcm0udjEuQWNjb3VudERlbGV0ZWRFdmVudEgAQgcKBWV2ZW50IjcKE0FjY291bnRDcmVhdGVkRXZlbnQSIAoHYWNjb3VudBgBIAEoCzIPLmNybS52MS5BY2NvdW50ImoKE0FjY291bnRVcGRhdGVkRXZlbnQSKQoQcHJldmlvdXNfYWNjb3VudBgBIAEoCzIPLmNybS52MS5BY2NvdW50EigKD3VwZGF0ZWRfYWNjb3VudBgCIAEoCzIPLmNybS52MS5BY2NvdW50IjcKE0FjY291bnREZWxldGVkRXZlbnQSIAoHYWNjb3VudBgBIAEoCzIPLmNybS52MS5BY2NvdW50QitaKXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWNybS9hcGkvdjE7Y3JtX3YxYghlZGl0aW9uc3DoBw", [file_crm_v1_account]);

/**
 * @generated from message crm.v1.AccountEvent
 */
export type AccountEvent = Message<"crm.v1.AccountEvent"> & {
  /**
   * @generated from oneof crm.v1.AccountEvent.event
   */
  event: {
    /**
     * @generated from field: crm.v1.AccountCreatedEvent created = 1;
     */
    value: AccountCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: crm.v1.AccountUpdatedEvent updated = 2;
     */
    value: AccountUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: crm.v1.AccountDeletedEvent deleted = 3;
     */
    value: AccountDeletedEvent;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message crm.v1.AccountEvent.
 * Use `create(AccountEventSchema)` to create a new message.
 */
export const AccountEventSchema: GenMessage<AccountEvent> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_events, 0);

/**
 * @generated from message crm.v1.AccountCreatedEvent
 */
export type AccountCreatedEvent = Message<"crm.v1.AccountCreatedEvent"> & {
  /**
   * @generated from field: crm.v1.Account account = 1;
   */
  account?: Account;
};

/**
 * Describes the message crm.v1.AccountCreatedEvent.
 * Use `create(AccountCreatedEventSchema)` to create a new message.
 */
export const AccountCreatedEventSchema: GenMessage<AccountCreatedEvent> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_events, 1);

/**
 * @generated from message crm.v1.AccountUpdatedEvent
 */
export type AccountUpdatedEvent = Message<"crm.v1.AccountUpdatedEvent"> & {
  /**
   * @generated from field: crm.v1.Account previous_account = 1;
   */
  previousAccount?: Account;

  /**
   * @generated from field: crm.v1.Account updated_account = 2;
   */
  updatedAccount?: Account;
};

/**
 * Describes the message crm.v1.AccountUpdatedEvent.
 * Use `create(AccountUpdatedEventSchema)` to create a new message.
 */
export const AccountUpdatedEventSchema: GenMessage<AccountUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_events, 2);

/**
 * @generated from message crm.v1.AccountDeletedEvent
 */
export type AccountDeletedEvent = Message<"crm.v1.AccountDeletedEvent"> & {
  /**
   * @generated from field: crm.v1.Account account = 1;
   */
  account?: Account;
};

/**
 * Describes the message crm.v1.AccountDeletedEvent.
 * Use `create(AccountDeletedEventSchema)` to create a new message.
 */
export const AccountDeletedEventSchema: GenMessage<AccountDeletedEvent> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_events, 3);

